export const isBrainStorm = (accountName: string) => accountName === "BrainStorm Global";
